import React from 'react';
import '@/index.css';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Sidebar from '@/components/layout/Sidebar';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import Ejecutar from '@/pages/Ejecutar';
import Posiciones from '@/pages/Posiciones';
import Historial from '@/pages/Historial';
import Estado from '@/pages/Estado';
import Auditoria from '@/pages/Auditoria';
import Logs from '@/pages/Logs';

function Shell({ children }) {
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="min-w-0">{children}</main>
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<ProtectedRoute><Shell><Dashboard /></Shell></ProtectedRoute>} />
      <Route path="/ejecutar" element={<ProtectedRoute><Shell><Ejecutar /></Shell></ProtectedRoute>} />
      <Route path="/posiciones" element={<ProtectedRoute><Shell><Posiciones /></Shell></ProtectedRoute>} />
      <Route path="/historial" element={<ProtectedRoute><Shell><Historial /></Shell></ProtectedRoute>} />
      <Route path="/logs" element={<ProtectedRoute><Shell><Logs /></Shell></ProtectedRoute>} />
      <Route path="/auditoria/:candidataId" element={<ProtectedRoute><Shell><Auditoria /></Shell></ProtectedRoute>} />
      <Route path="/estado" element={<ProtectedRoute><Shell><Estado /></Shell></ProtectedRoute>} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  React.useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
